import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import GamesTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useIntl } from 'umi';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import {
  sortTableByMetric,
  getItemFromArray,
} from '@/pages/intelligence/utils/tableUtils';

const EditionsShareCard = (props: any) => {
  const {
    chartType,
    setChartType,
    fixedTableData,
    tableData = [],
    lineData,
    cardStatus,
    tableTotal,
    dateType,
    startDate,
    endDate,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,

    tabId,
    setChartLoading,
    chartLoading,
    gameName,
    barOrPieList,
    entityType,
  } = props;

  // const infoItem = getItemFromArray({
  //   list: newzooList,
  //   key: 'value',
  //   keyVal: 'mau',
  // });
  const { rpdSegementOptions, rpdSegementTitleObj } = useMobileOptionList();

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [chartType, setChartType] = useState('bar');
  const [metricSegVal, setMetricSegVal] = useState(rpdSegementOptions[0].value);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_games_share` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_games_share` })}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={tabId}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-game'}
            titleNow={tabId === 'revenue' ? 'Revenue' : tabId}
            tableData={barOrPieList} //不要用tableData, 排序和分页表格数据会变
            gameName={gameName}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <GamesTable
          entityType={entityType}
          tableTotal={tableTotal}
          tableData={tableData}
          dateType={dateType}
          // infoItem={infoItem}
          columnsList={columnsList}
          tableLoading={tableLoading}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
        />
      </CardSlotV2>
    </div>
  );
};

export default EditionsShareCard;
